module.exports = __webpack_public_path__ + "static/media/grass_fed_beef_desktop_fr.6d6a01e5.jpg";